//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionLibs from "utils/regionSeatLibs";
import {
  getSessionStorageQuery,
  setSessionStorageQuery,
} from "@/utils/common.js";
let regionData = JSON.parse(JSON.stringify(regionLibs[0].c));
export default {
  name: "CooperativeApplyList",
  $dictKeyList: [
    {
      key: "1",
      name: "状态",
    },
  ],
  data() {
    return {
      filterForm: {
        provinceId: "",
        cityId: "",
        areaId: "",
        cooperativeName: "",
        liainsonNameOrCorName: "",
        loginMobile: "",
        applyStatus: "",
        ascOrDesc: "3", //排序  2：升序  3：降序
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],

      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
        checkStrictly: this.dataSource == 2 ? false : true,
      },
      regionData,
      dicts: {
        applyStatus: [],
      },
    };
  },
  props: {
    dataSource: {
      type: Number,
    },
  },
  filters: {},
  watch: {
    checkedRegionData(newVal) {
      this.filterForm.provinceId = newVal[0] || "";
      this.filterForm.cityId = newVal[1] || "";
      this.filterForm.areaId = newVal[2] || "";
    },
  },
  created() {},
  mounted() {
    this.setCacheData();
    this.getCooperativeList();
  },
  methods: {
    // 设置缓存过的数据 比如查询条件 和 tab
    setCacheData() {
      const cache = getSessionStorageQuery();
      if (!cache || cache.activeName !== "2") return;
      this.filterForm = cache.filterForm;
      this.pagination = cache.pagination;
      const { provinceId, cityId, areaId } = cache.filterForm;
      this.dataSource = cache.dataSource;
      this.checkedRegionData = [provinceId, cityId, areaId];
    },

    timeSortChange(val) {
      switch (val.order) {
        case "ascending":
          this.filterForm.ascOrDesc = "2";
          break;
        case "descending":
          this.filterForm.ascOrDesc = "3";
          break;
      }
      this.handleFilter();
    },
    // 查询
    handleFilter() {
      this.pagination.page = 1;
      this.getCooperativeList();
    },
    //获取列表数据
    getCooperativeList() {
      let params = Object.assign({}, this.filterForm, {
        dataSource: this.dataSource,
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.cooperative.applyExamineListFilter(params).then((res) => {
        this.tableData = res.data.content;
        if (this.pagination.page == 1)
          this.pagination.total = res.data.recordTotal;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedRegionData = [];
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCooperativeList();
    },
    // 查看
    toDetail(id) {
      this.$router.push({
        path: "/cooperative/apply-examine/detail",
        query: { cooApplyId: id, dataSource: this.dataSource },
      });
    },
    // 审核
    toExamine(id) {
      setSessionStorageQuery({
        filterForm: this.filterForm,
        pagination: this.pagination,
        dataSource: this.dataSource,
        activeName: "2",
      });
      let params = Object.assign({}, this.filterForm, {
        dataSource: this.dataSource,
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$router.push({
        path: "/cooperative/apply-examine/examine",
        query: { cooApplyId: id, dataSource: this.dataSource },
      });
    },
  },
};
